import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Auth from 'providers/Auth';
import CourseProvider from 'providers/Course';
import Router from 'router/index';

const App = () => (
  <>
    <Auth>
      <CourseProvider>
        <Router />
      </CourseProvider>
    </Auth>
    <ToastContainer
      position="bottom-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  </>
);

export default App;
